export default __webpack_public_path__ + "static/media/girl3.46f7c62b.svg";